import { validateCompliance } from "utils";

export const formFields = [

    {
      label: 'Η  Αίτηση Χρηματοδότησης επέχει τη θέση υπεύθυνης δήλωσης του Ν. 1599/1986, ως προς την ακρίβεια των στοιχείων που αναγράφονται σε αυτήν. Οποιαδήποτε ψευδή αναφορά ή αναντιστοιχία με τα πραγματικά στοιχεία, πέραν των οικονομικών επιπτώσεων, ενδέχεται να επιφέρει και ποινικές κυρώσεις.',
      id: 'terms1',
      name: 'terms1',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Σε περίπτωση μη επίτευξης του στόχου μείωσης πρωτογενούς ενέργειας κατά 30%, εκδίδεται απόφαση ανάκλησης της απόφασης ένταξης.',
      id: 'terms2',
      name: 'terms2',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Ο δικαιούχος φορέας οφείλει να τηρεί ξεχωριστή λογιστική καταχώρηση για την πράξη ή να διαθέτει επαρκή λογιστική κωδικοποίηση από την οποία να προκύπτει η καταχώρηση όλων των δαπανών που αντιστοιχούν πλήρως προς τις δαπάνες που δηλώνονται.',
      id: 'terms3',
      name: 'terms3',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: ' Αποδέχεται τη δυνατότητα διενέργειας επιτόπιων ελέγχων από αρμόδια Εθνικά και Ευρωπαϊκά ελεγκτικά όργανα, καθώς και από τον Ανεξάρτητο Ελεγκτή, τόσο στην έδρα του όσο και στους χώρους υλοποίησης του έργου, και δεσμεύεται να διευκολύνει τον έλεγχο προσκομίζοντας οποιοδήποτε στοιχείο αφορά την εκτέλεση του έργου, εφόσον ζητηθεί.',
      id: 'terms4',
      name: 'terms4',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Σε περίπτωση ένταξης, ο  Δικαιούχος Φορέας οφείλει να υλοποιεί την επένδυση σύμφωνα με όσα προβλέπονται στην Πρόσκληση του Προγράμματος.',
      id: 'terms5',
      name: 'terms5',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Υποχρεούται να παρέχει όλα τα ζητούμενα στοιχεία και δικαιολογητικά για την αποτίμηση της επίτευξης των στόχων.',
      id: 'terms6',
      name: 'terms6',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Αποστέλλει στο Φορέα Υλοποίησης και Ελέγχου όλα τα σχετικά έγγραφα για τον έλεγχο των μακροχρόνιων υποχρεώσεων, όταν ζητηθούν εγγράφως.',
      id: 'terms7',
      name: 'terms7',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Διασφαλίζει την αποφυγή διπλής χρηματοδότησης της πράξης μέσω άλλων προγραμμάτων ή πόρων καθώς και την αποφυγή παρατυπιών ',
      id: 'terms8',
      name: 'terms8',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Ο Δικαιούχος Φορέας επιβεβαιώνει ότι η προτεινόμενη επέμβαση στο κτίριο δεν έχει ήδη ενταχθεί για χρηματοδότηση σε κάποιο άλλο χρηματοδοτούμενο πρόγραμμα και ότι δεν υφίσταται άμεσα δυνατότητα να ενταχθεί',
      id: 'terms9',
      name: 'terms9',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Υποχρεούται να διασφαλίσει την ορθή και κατά το νόμο εναλλακτική διαχείριση των αποβλήτων από εκσκαφές, κατασκευές και κατεδαφίσεις (Α.Ε.Κ.Κ.)',
      id: 'terms10',
      name: 'terms10',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Υποχρεούται να συμμορφώνεται με τις απαιτήσεις της παρ. 12 του άρθρου 7 του ν. 4342/2015 περί υποβολής  Σχεδίου Ενεργειακής Απόδοσης Κτιρίων (ΣΕΑΚ)',
      id: 'terms11',
      name: 'terms11',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Το προτεινόμενο κτίριο οφείλει να εξασφαλίζει την προσβασιμότητα στα Άτομα Με Ειδικές Ανάγκες, σύμφωνα με το ισχύον θεσμικό πλαίσιο',
      id: 'terms12',
      name: 'terms12',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    
  ];